import { render } from "./Vote.vue?vue&type=template&id=58257d2d&scoped=true"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"

import "./Vote.vue?vue&type=style&index=0&id=58257d2d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58257d2d"]])

export default __exports__